import _ from "lodash"; 
import { useAuth } from "../../../../../../../auth/context";
import medicusVademecum from "./medicusVademecum.json";
import vademecum from "./vademecum";

export default () => {
  const { user } = useAuth();
  const healthCenterName = user.profile.healthCenter?.name;
  
  if (healthCenterName == "Medicus") return medicusVademecum;
  return vademecum;
};